var map = {
	"./ACHARYA.png": 4895,
	"./AVINASH.png": 3295,
	"./Academic1.png": 5669,
	"./Academic2.png": 9570,
	"./Academic3.png": 5982,
	"./Academic4.png": 8797,
	"./Academic5.png": 4561,
	"./Aspiration.png": 122,
	"./BAPPA.png": 8842,
	"./BillWhisenhunt.png": 8860,
	"./Business1.png": 2931,
	"./Business2.png": 6633,
	"./Business3.png": 4557,
	"./Business4.png": 9872,
	"./Business5.png": 1328,
	"./DEVENDER.png": 4462,
	"./Gopika.png": 1911,
	"./Govt1.png": 5083,
	"./Govt2.png": 1009,
	"./Govt3.png": 3753,
	"./Govt4.png": 5129,
	"./Hyderabad.png": 6935,
	"./Industry1.png": 6222,
	"./Industry2png.png": 9234,
	"./Industry3.png": 7903,
	"./KAPIL.png": 7946,
	"./Kharagpur.png": 6020,
	"./Long Distance Measurement Device Independent-Quantum Secure Direct Communication protocol with EPR pairs.png": 1148,
	"./Measurement Device Independent-QSDC with user authentication. (2).png": 7539,
	"./MissionVision.png": 3925,
	"./Optimal quantum routing protocol and path finding algorithm for quantum network.png": 3088,
	"./Post-Quantum Cryptography.png": 5550,
	"./Q-FolioPro.png": 6983,
	"./Quantum Memories (Rare earth doped Transition Metal Dichalcogenide thin film for quantum storage of light).png": 1532,
	"./Quantum Memories (Ultra-long storage assisted 2nd Gen Quantum Memory using intrananotube double-dot heterostructures).png": 4030,
	"./Quantum Random Number Generation (A software QRNG with Digital Quantum Simulation).png": 9842,
	"./Quantum Secure Direct Communication with mutual authentication via rotation of an arbitrary basis..png": 3747,
	"./QuantumAI.png": 7598,
	"./QuantumCommunication.png": 34,
	"./QuantumEducation.png": 9734,
	"./QuantumMemory.png": 1707,
	"./QuantumSimulations.png": 6234,
	"./Qulabs.png": 6617,
	"./RAM THEJA.png": 5354,
	"./RIKTHIM.png": 9651,
	"./Roorkee.png": 6588,
	"./SACHIN.png": 3813,
	"./SANJAY.png": 645,
	"./Secure Multiparty Quantum Conference.png": 7710,
	"./Secure quantum multi party XOR protocol.png": 9960,
	"./Simulator for Quantum Computing systems..png": 1156,
	"./Software platform for modelling and simulation of Quantum Network communication system..png": 9597,
	"./Techniques Of Quantum Computing Model.png": 2278,
	"./Vision.png": 9611,
	"./checq.png": 5297,
	"./image 1.png": 8094,
	"./image 2.png": 4572,
	"./image 3.png": 4138,
	"./image 4.png": 9220,
	"./image 6.png": 1021,
	"./image 7.png": 8318,
	"./image 8 .png": 4183,
	"./image 9.png": 8965,
	"./logo.png": 7929,
	"./qcloud.png": 6555,
	"./qntsm.png": 3940,
	"./qurng.png": 1158,
	"./roboqop.png": 3,
	"./tickicon.png": 8546
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4384;